import script from "./WidgetSlideover.vue?vue&type=script&setup=true&lang=js"
export * from "./WidgetSlideover.vue?vue&type=script&setup=true&lang=js"

import "./WidgetSlideover.vue?vue&type=style&index=0&id=ec5822ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ec5822ea"]])

export default __exports__